// reading.js — «Lesestreifen»: read a sentence group by group, and before
// each group is uncovered say which Satzglied has to come next.
//
// The first group is visible. Below the sentence sits a palette of labels;
// the chip the student picks is compared with the role of the next group,
// then that group appears with its label. The pick counts on the first try
// per group, nothing can be undone, and the sentence is always read to the
// end. Markup comes from reading.lua.

// Label text comes from the author's labels= list; set it as text, not markup.
function textSpan(className, text) {
    const span = document.createElement('span');
    span.className = className;
    span.textContent = text;
    return span;
}

const READY = 'data-ph-rd-ready';

function utf8FromBinary(bin) {
    let escaped = '';
    for (let i = 0; i < bin.length; i += 1) {
        escaped += '%' + bin.charCodeAt(i).toString(16).padStart(2, '0');
    }
    try {
        return decodeURIComponent(escaped);
    } catch (_) {
        return bin;
    }
}

function decodeSolution(root) {
    try {
        return JSON.parse(utf8FromBinary(atob(root.dataset.solution || '')));
    } catch (err) {
        console.error('[reading] undecodable solution', err);
        return { items: [] };
    }
}

class Reading {
    constructor(root) {
        this.root = root;
        this.labels = JSON.parse(root.dataset.labels || '[]');
        this.solution = decodeSolution(root);
        this.items = Array.from(root.querySelectorAll('.ph-rd-item')).map((el, index) => ({
            el,
            index,
            groups: Array.from(el.querySelectorAll('.ph-rd-group')),
            roles: (this.solution.items || [])[index] || [],
            shown: 0,
            hits: 0,
            picks: 0,
            done: false,
        }));

        this.items.forEach((item) => this.build(item));
        if (root.dataset.reveal === '1') {
            this.items.forEach((item) => this.revealAll(item));
        }
        root.setAttribute(READY, '1');
    }

    colourOf(code) {
        const entry = this.labels.find(([c]) => c === code);
        const role = entry && entry[2];
        if (role) return `ph-sm-role-${role}`;
        const i = this.labels.findIndex(([c]) => c === code);
        return `ph-sm-c${(i % 8) + 1}`;
    }

    build(item) {
        item.groups.forEach((g, gi) => {
            g.classList.toggle('ph-rd-hidden', gi > 0);
            if (gi === 0) g.classList.add('ph-rd-shown');
        });
        item.shown = 1;

        const bar = document.createElement('div');
        bar.className = 'ph-rd-palette';
        const hint = document.createElement('span');
        hint.className = 'ph-rd-hint';
        hint.textContent = 'Was kommt als Nächstes?';
        bar.appendChild(hint);
        const chips = document.createElement('div');
        chips.className = 'ph-sm-chips';
        item.chips = this.labels.map(([code, name]) => {
            const chip = document.createElement('button');
            chip.type = 'button';
            chip.className = `ph-sm-chip ${this.colourOf(code)}`;
            chip.dataset.code = code;
            chip.title = name;
            chip.append(textSpan('ph-sm-chip-code', code), textSpan('ph-sm-chip-name', name));
            chip.addEventListener('click', () => this.pick(item, code));
            chips.appendChild(chip);
            return chip;
        });
        bar.appendChild(chips);
        item.el.appendChild(bar);
        item.palette = bar;
        item.feedback = item.el.querySelector('.ph-rd-feedback');
        if (item.groups.length < 2) this.finish(item);
    }

    tag(group, code, ok) {
        const t = document.createElement('span');
        t.className = `ph-rd-tag ${this.colourOf(code)}` + (ok === undefined ? '' : (ok ? ' ph-rd-ok' : ' ph-rd-miss'));
        t.textContent = code + (ok === undefined ? '' : (ok ? ' ✓' : ' ✗'));
        group.appendChild(t);
    }

    pick(item, code) {
        if (item.done) return;
        const gi = item.shown;
        const expected = item.roles[gi];
        const ok = code === expected;
        item.picks += 1;
        if (ok) item.hits += 1;
        const group = item.groups[gi];
        group.classList.remove('ph-rd-hidden');
        group.classList.add('ph-rd-shown', ok ? 'ph-rd-group-ok' : 'ph-rd-group-miss');
        this.tag(group, expected, ok);
        item.shown += 1;
        if (item.shown >= item.groups.length) this.finish(item);
    }

    finish(item) {
        item.done = true;
        if (item.palette) item.palette.remove();
        const n = item.groups.length - 1;
        if (n > 0 && item.feedback) {
            item.feedback.textContent = `${item.hits} von ${n} erwartet`;
        }
        this.root.dispatchEvent(new CustomEvent('ph-reading-item', { bubbles: true, detail: { hits: item.hits, total: n } }));
    }

    revealAll(item) {
        item.groups.forEach((g, gi) => {
            g.classList.remove('ph-rd-hidden');
            g.classList.add('ph-rd-shown');
            if (gi > 0) this.tag(g, item.roles[gi]);
        });
        item.done = true;
        if (item.palette) item.palette.remove();
    }
}

export function initReading() {
    const roots = document.querySelectorAll('.ph-rd[data-ph-rd]');
    if (!roots.length) return;
    console.log('[reading] init', { count: roots.length });
    roots.forEach((root) => {
        if (root.getAttribute(READY)) return;
        try {
            new Reading(root);
        } catch (err) {
            console.error('[reading] init failed', err);
        }
    });
}
